import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollSavedCustomFieldViewResponse,
  PayrollSavedCustomFieldViewVariables,
} from '../types';

export const getSavedCustomFieldViewQuery = gql`
  query PayrollSavedCustomFieldView($viewType: PayrollSavedViewType!) {
    payrollSavedCustomFieldView(viewType: $viewType) {
      viewType
      fieldKeys
      updatedBy
      updatedAt
      fieldDefinitions {
        id
        fieldKey
        label
        valueType
        origin
        enumValues
        usages
        filterable
        section
        groupKey
        displayOrder
      }
    }
  }
`;

export const getSavedCustomFieldView = (
  queryVariables: PayrollSavedCustomFieldViewVariables,
) =>
  graphQLApi<PayrollSavedCustomFieldViewResponse, PayrollSavedCustomFieldViewVariables>({
    query: getSavedCustomFieldViewQuery,
    queryVariables,
  });
